/* eslint-disable no-console */
import { gridConfig, GridContainer, GridItem, GridRow } from '@tvg/fuse-design/responsive-grid';
import { EUserAction } from 'client/config';
import useMediaQuery from 'client/hooks/useMediaQuery';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import useSSR from 'use-ssr';

import Plpurl from '@tvg/product-listing-url';
import { useMainState } from 'client/state/Main';
import CardGrid from '../CardGrid';
import { Drawer } from '../Drawer/Drawer';
import Facet from '../Facet';
import { Spinner } from '../Spinner/Spinner';
import Events from './Events';

const GridContainerStyled = styled(GridContainer)`
  &.product-listing__main-container {
    padding-bottom: var(--spacing-space64);
  }

  & .product-listing__main-content {
    align-items: start;
  }
`;

function Main() {
  const setLastAction = useMainState((s) => s.setLastAction);
  const setPLPURL = useMainState((s) => s.setPLPURL);
  const { isBrowser } = useSSR();

  const isDesktop = useMediaQuery(`(min-width: ${gridConfig.l.minWidth})`);

  useEffect(() => {
    // eslint-disable-next-line no-underscore-dangle
    window._uxa = window._uxa || [];
    try {
      // eslint-disable-next-line no-underscore-dangle
      window._uxa.push(['setCustomVariable', 17, 'tvgPlatform', 'skyscape', 3]);
    } catch (error) {
      /* istanbul ignore next */
      console.log('Error creating Content Square custom variable: ', error);
    }
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      setPLPURL(new Plpurl(`${window.location.pathname}${window.location.search}`));
      setLastAction(EUserAction.BROWSER_ACTION);
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [setLastAction, setPLPURL]);

  useEffect(() => {
    const userIdFromCookie = Cookies.get('COID');
    if (userIdFromCookie) {
      window.cnstrcUserId = userIdFromCookie as string;
    }
  }, []);

  return (
    <GridContainerStyled className="product-listing__main-container container">
      <GridRow className="row product-listing__main-content">
        <Facet />

        <GridItem xxs="12" l="9" className="grid-item">
          <CardGrid />
        </GridItem>
      </GridRow>
      {isBrowser && !isDesktop && (
        <>
          <Spinner />
          <Drawer />
        </>
      )}
      <Events />
    </GridContainerStyled>
  );
}

export default React.memo(Main);
